( function ( _s ) {
	_s.fn.searchForm = function () {
		return this.each( searchForm => {
			const _searchForm = _s( searchForm );
			const _toggle = _searchForm.find( '.search-toggle' );
			const _searchInput = _searchForm.find( '[type="search"]' );
			// DEAD IN PATH — always 0, and was so before the header was rebuilt: the
			// PATH header renders no search form, so `.fr-search-form` only ever exists
			// on the search results page, never inside `.navbar-desktop`. The
			// toggle/outside-click branch below is therefore never entered here.
			// Left intact because this is starter code that seeds the next build (see
			// modules/_main-menu.scss). If a header search form is ever added to PATH,
			// re-point this at `.nav-links` rather than deleting it.
			const isDesktopHeaderSearchForm = _searchForm.closest( '.navbar-desktop' ).length;

			const toggle = () => {
				_searchForm.toggleClass( 'show-form' );
			};

			const hide = () => {
				_searchForm.removeClass( 'show-form' );
			};

			if ( isDesktopHeaderSearchForm ) {
				_toggle.on( 'click', () => {
					toggle();
				} );

				_toggle.on( 'keyup', e => {
					if ( e.key === 'Enter' ) {
						toggle();
					}
				} );

				_s( window ).on( 'fr:body-click', e => {
					const _target = _s( e.detail.event.target );

					if ( ! _searchForm.contains( _target ) ) {
						hide();
					}
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		_s( '.fr-search-form' ).searchForm();
	} );
} )( window._s );
